import React, { Component } from 'react'
import { Row, Col, Alert, Progress, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap'
import Select from 'react-select'
import withApolloClient from '../withApolloClient'
import { gql } from '@apollo/client'
import "./IncompleteReturnForm.css"

const IncompleteReasons = [
    { value: "Repo Return", label: "Repo Return" },
    { value: "Mechanical Switch", label: "Mechanical Switch" },
    { value: "Accident Switch", label: "Accident Switch" },
    { value: "Final Return", label: "Final Return" },
    { value: "Lost", label: "Lost" },
]

const CREATE_INCOMPLETE_RETURN = gql`
    mutation CreateIncompleteReturn($input: CreateIncompleteReturnInput!) {
        createIncompleteReturn(input: $input) {
            ok
            errors {
                field
                messages
            }
        }
    }
`

const UPDATE_INCOMPLETE_RETURN = gql`
    mutation UpdateIncompleteReturn($input: UpdateIncompleteReturnInput!) {
        updateIncompleteReturn(input: $input) {
            ok
            errors {
                field
                messages
            }
        }
    }
`

class IncompleteReturnForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            incompleteReason: props.editReturn ? props.carReturn.returnReason : "",
            notes: props.editReturn ? props.carReturn.notes : "",
            isImpound: props.editReturn ? props.carReturn.isImpound : false,
            impoundAddress: props.editReturn ? props.carReturn.impoundAddress : "",
            loading: false,
            error: null,
            openModal: "",
            isValidLength: true,
        }
    }

    updateInput = (e) => {
        const name = e.target.name
        const value = e.target.value
        const charCount = value.length
        const isValidLength = charCount >= 35 && charCount <= 250

        this.setState({
            [name]: value,
            isValidLength,
        })
    }

    handleClose = () => {
        this.setState({
            loading: false,
            error: null,
            openModal: "",
            incompleteReason: "",
            notes: "",
            isValidLength: true
        })

        if (this.props.refetchQuery) {
            this.props.refetchQuery()
        }
        this.props.handleClose()
    }

    handleSubmit = () => {
        if (!this.state.isValidLength) {
            this.setState({ error: "Notes must be between 10-150 characters" })
            return
        }

        try {
            this.setState({ loading: true, error: null })
            let input = {}
            if (this.props.editReturn) {
                input.id = this.props.carReturn.id
                input.incompleteReason = this.state.incompleteReason
                input.notes = this.state.notes
                input.isImpound = this.state.isImpound
                input.impoundAddress = this.state.isImpound ? this.state.impoundAddress : null
            } else {
                input = {
                    rentalId: this.props.rentalId,
                    incompleteReason: this.state.incompleteReason,
                    notes: this.state.notes,
                    isImpound: this.state.isImpound,
                    impoundAddress: this.state.isImpound ? this.state.impoundAddress : null,
                }
                if (!input.incompleteReason || !input.notes) {
                    this.setState({
                        loading: false,
                        error: "Both reason and notes are required for new incomplete returns"
                    })
                    return
                }
            }
            this.props.apolloClient.mutate({
                mutation: this.props.editReturn ? UPDATE_INCOMPLETE_RETURN : CREATE_INCOMPLETE_RETURN,
                variables: { input },
            }).then((result) => {
                if (result.data && ((this.props.editReturn && result.data.updateIncompleteReturn && result.data.updateIncompleteReturn.ok) || (!this.props.editReturn && result.data.createIncompleteReturn && result.data.createIncompleteReturn.ok))) {
                    this.setState({ loading: false })
                    this.handleClose()
                } else {
                    let errorMessage = "An error has occurred. Please contact system admin"
                    if (this.props.editReturn && result.data.updateIncompleteReturn && result.data.updateIncompleteReturn.errors) {
                        errorMessage = result.data.updateIncompleteReturn.errors.map(err => err.messages.join(', ')).join('\n')
                    } else if (!this.props.editReturn && result.data.createIncompleteReturn && result.data.createIncompleteReturn.errors) {
                        errorMessage = result.data.createIncompleteReturn.errors.map(err => err.messages.join(', ')).join('\n')
                    }

                    this.setState({
                        loading: false,
                        error: errorMessage
                    })
                }
            }).catch((error) => {
                this.setState({
                    error: `An error has occurred: ${error.message || 'Unknown error'}`,
                    loading: false
                })
            })
        } catch (err) {
            this.setState({
                error: `An error has occurred: ${err.message || 'Unknown error'}`,
                loading: false
            })
        }
    }

    renderWordCountStatus = () => {
        let wordCount = this.state.notes.length
        const minWords = 35
        const maxWords = 250

        let statusText = ''
        let statusClass = 'text-muted'

        if (wordCount < minWords) {
            statusText = `${minWords - wordCount} more characters required (${wordCount}/${maxWords})`
            statusClass = 'text-danger'
        } else if (wordCount > maxWords) {
            statusText = `${wordCount - maxWords} characters over limit (${wordCount}/${maxWords})`
            statusClass = 'text-danger'
        } else {
            statusText = `(${wordCount}/${maxWords})`
            statusClass = 'text-success'
        }

        return (
            <div className={`word-count-status ${statusClass}`}>
                {statusText}
            </div>
        )
    }

    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }

    render() {
        const { editReturn, rentalId, open } = this.props
        const { incompleteReason, notes, loading, error, isValidLength } = this.state

        return (
            <div>
                <Modal className="incomplete-return-modal" isOpen={open}>
                    {rentalId && (
                        <>
                            <ModalHeader>{editReturn ? "Edit" : "Incomplete"} Return</ModalHeader>
                            <ModalBody>
                                {loading && <Row><Col xs={12}><Progress animated color="info" value={100} /></Col></Row>}
                                {error && <Row><Col xs={12}><Alert color="danger">{error}</Alert></Col></Row>}

                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label for="returnType">Incomplete Reason</Label>
                                            <Select
                                                className="bos-custom-select"
                                                classNamePrefix="bos-select"
                                                name="incompleteReason"
                                                options={IncompleteReasons}
                                                placeholder={'Select Incomplete Reason'}
                                                value={incompleteReason ? IncompleteReasons.find(opt => opt.value === incompleteReason) : null}
                                                onChange={(selected) => this.setState({ incompleteReason: selected ? selected.value : null })}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label for="notes">Brief Description (10-150 characters)</Label>
                                            <Input
                                                type="textarea"
                                                name="notes"
                                                value={notes}
                                                onChange={this.updateInput}
                                                placeholder="Please write briefly about the incomplete return"
                                                className={!isValidLength ? "is-invalid" : ""}
                                            />
                                            {this.renderWordCountStatus()}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup check>
                                            <Input id="impound" type="checkbox" name="impound" checked={this.state.isImpound} onChange={() => this.setState({ isImpound: !this.state.isImpound })} />
                                            <Label for="impound">Impound?</Label>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {this.state.isImpound && <Row>
                                    <Col>
                                        <Label for="impoundAddress">Impound Address</Label>
                                        <Input
                                            type="text"
                                            name="impoundAddress"
                                            value={this.state.impoundAddress}
                                            onChange={(e) => this.setState({ impoundAddress: e.target.value })}
                                            placeholder="Enter the address where the vehicle is impounded"
                                        />
                                    </Col>
                                </Row>}
                            </ModalBody>
                        </>
                    )}

                    <ModalFooter>
                        {!loading && (
                            <div className="text-right">
                                <Button className="incomplete-return-modal-secondary-btn" onClick={this.handleClose}>Close</Button>&nbsp;&nbsp;
                                <Button
                                    className="incomplete-return-modal-primary-btn"
                                    onClick={this.handleSubmit}
                                    disabled={loading || (!editReturn && (!incompleteReason || !notes || !isValidLength))}
                                >
                                    {editReturn ? "Update" : "Submit"}
                                </Button>
                            </div>
                        )}
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default (withApolloClient(IncompleteReturnForm))